import React, { Component } from 'react';
import $ from 'jquery';
import { browserHistory} from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

export default class Web_MobVerifyOtp extends Component {
	constructor(props,context){
		super(props);
		this.state={
			mobile: localStorage.getItem('mobile_number'),
			invalid_otp: '',
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.gotoLogin= this.gotoLogin.bind(this);
		this.resendOtp = this.resendOtp.bind(this);
	}
	componentDidMount(){
		this.refs.otp.focus();
	}
	resendOtp(){
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1= {from:'desktop_web',mobile: this.state.mobile};
		var data2= JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'social_rsend_otp',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				// console.log(data);
			},
			error: function(err){
				// console.log(err);
			}
		});
	}
	handleSubmit(event){
		event.preventDefault();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1= {from: 'desktop_web',mobile: localStorage.getItem('mobile_number'),otp: this.refs.otp.value,device_id: localStorage.getItem('push_device_id')};
		var data2 = JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'social_otp_auth',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				if(data.status === 'success' && data.page_source==="dashboard"){
					localStorage.setItem('token',data.token);
					localStorage.setItem('user_id',data.uid);
					browserHistory.push('/web/home');
				}
				if(data.status==='error'){
					this.setState({
						err:true,
						invalid_otp: 'OTP mis match',
					});
				}
			}.bind(this),
			error: function(err){
			}
		})
	}
	gotoLogin(event){
		event.preventDefault();
		browserHistory.push('/web/login');
	}
	
	render(){
	return(
<div className="lgt_gry web_deals web_scl_verifyotp_page">
	<WebHeaderInner />
    <div className="clr">&nbsp;</div>
    <div className="clr">&nbsp;</div>
<section className="container dels_cntnt">
<div className="row">
  <div className="col-md-12 del_rgt">
    <div className="del_rgt_blk">
	<div className="del_dtl">
	  	<div className="">
		    <div className="col-md-6 col-md-offset-3">
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
	   	    <div className="thumbnail">
			    	<div className="newlogin_logo"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
			    	<div className="">
			    		<div className="clr">&nbsp;</div>
			     		<form className="mtrl_elmnts" onSubmit={this.handleSubmit}>
				        	<div className="col-md-12">
			        			<div className="col-md-12">
			        				<div className="group">      
			         					<input type="text" ref="otp" maxLength={6} required onChange={this.otpChange} />
			          					<span className="highlight"></span>
										<span className="bar"></span>
										<span style={{fontSize:'11px',color:'red'}}>{this.state.err ? this.state.invalid_otp : ''}</span>
										<label>Enter OTP</label>
			        				</div>
			        			</div>
			        			<button onSubmit={this.handleSubmit.bind(this)} action="submit" className="btn web_scl_verify_btn">VERIFY <i className="glyphicon glyphicon-menu-right"></i></button>
			        		</div>
			        		<div className="clr">&nbsp;</div>
			        		<div className="clr">&nbsp;</div>
			        		<div className="forgot_pasword">
			                    <h5>Didn't recieve the OTP?</h5>
			                    <div className="tap" >
			                   		<a onClick={this.resendOtp}>Tap Here to Resend</a>
			                    </div>
			                </div>  
			   			</form>
			    	</div>
			    	<div className="clr">&nbsp;</div>
			    </div>
	    {/* <!-- login form end --> */}
			</div>
	    </div>
  {/*  <!-- customer care end --> */}
	  	<div className="clr">&nbsp;</div>
	  	<div className="clr">&nbsp;</div>
  	</div>
      </div>
    </div>

  </div>

<div className="clr">&nbsp;</div> 
<div className="clr">&nbsp;</div>
</section>
<WebFooter />
</div>
);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Auth/Web_mob_verify_otp.js
 **/